import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useEffect } from "react";

const BlockContent = (props) => {
    const { blockInfo } = props;
    useEffect(() => {
        console.log(blockInfo);
    }, [blockInfo]);
    return (
        <>
            <table className="text-sm text-left w-full rtl:text-right text-gray-500 border border-1 border-gray-100 rounded-l">
                <tbody>
                    <tr className="odd:bg-white even:bg-gray-50 border-b">
                        <td className="px-6 py-4 w-10 font-medium text-gray-900 whitespace-nowrap">
                            Transaction Hash
                        </td>
                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                            {Object.keys(blockInfo).length === 0 ? (
                                <Skeleton />
                            ) : (
                                blockInfo?.hash
                            )}
                        </td>
                    </tr>
                    <tr className="odd:bg-white even:bg-gray-50 border-b">
                        <td className="px-6 py-4 w-10 font-medium text-gray-900 whitespace-nowrap">
                            Block Number
                        </td>
                        <Link to={`/block/${blockInfo?.blockNumber}`}>
                            <td className="px-6 py-4 font-medium text-blue-400 whitespace-nowrap hover:underline">
                                {Object.keys(blockInfo).length === 0 ? (
                                    <Skeleton />
                                ) : (
                                    blockInfo?.blockNumber
                                )}
                            </td>
                        </Link>
                    </tr>
                    <tr className="odd:bg-white even:bg-gray-50 border-b">
                        <td className="px-6 py-4 w-10 font-medium text-gray-900 whitespace-nowrap">
                            Timestamp
                        </td>
                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                            {Object.keys(blockInfo).length === 0 ? (
                                <Skeleton />
                            ) : (
                                new Date(
                                    blockInfo?.timestamp * 1000
                                )?.toLocaleDateString("en-En", {
                                    weekday: "long",
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                })
                            )}
                        </td>
                    </tr>
                    <tr className="odd:bg-white even:bg-gray-50 border-b">
                        <td className="px-6 py-4 w-10 font-medium text-gray-900 whitespace-nowrap">
                            From
                        </td>
                        <Link to={`/wallet/${blockInfo.from}`}>
                            <td className="px-6 py-4 font-medium text-blue-400 hover:underline whitespace-nowrap">
                                {Object.keys(blockInfo).length === 0 ? (
                                    <Skeleton />
                                ) : (
                                    blockInfo?.from
                                )}
                            </td>
                        </Link>
                    </tr>
                    <tr className="odd:bg-white even:bg-gray-50 border-b">
                        <td className="px-6 py-4 w-10 font-medium text-gray-900 whitespace-nowrap">
                            To
                        </td>
                        <Link to={`/wallet/${blockInfo.to}`}>
                            <td className="px-6 py-4 font-medium text-blue-400 hover:underline whitespace-nowrap">
                                {Object.keys(blockInfo).length === 0 ? (
                                    <Skeleton />
                                ) : (
                                    blockInfo?.to
                                )}
                            </td>
                        </Link>
                    </tr>
                    <tr className="odd:bg-white even:bg-gray-50 border-b">
                        <td className="px-6 py-4 w-10 font-medium text-gray-900 whitespace-nowrap">
                            Value
                        </td>
                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                            {Object.keys(blockInfo).length === 0 ? (
                                <Skeleton />
                            ) : (
                                `${
                                    parseInt(blockInfo?.value?._hex, 16) / 1e18
                                } ETH`
                            )}
                        </td>
                    </tr>
                    <tr className="odd:bg-white even:bg-gray-50 border-b">
                        <td className="px-6 py-4 w-10 font-medium text-gray-900 whitespace-nowrap">
                            Transaction Fee
                        </td>
                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                            ?
                        </td>
                    </tr>
                    <tr className="odd:bg-white even:bg-gray-50 border-b">
                        <td className="px-6 py-4 w-10 font-medium text-gray-900 whitespace-nowrap">
                            Gas Price
                        </td>
                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                            {Object.keys(blockInfo).length === 0 ? (
                                <Skeleton />
                            ) : (
                                `${
                                    parseInt(blockInfo?.gasPrice?._hex, 16) /
                                    1e9
                                } Gwei`
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default BlockContent;
